import { Controller, useFormContext } from 'react-hook-form';

import { AkselLocale, Fieldset } from 'components/form/aksel';

export default function CheckboxGroup({
	name,
	label = null,
	required = false,
	children,
	...props
}) {
	if (!children) {
		console.error('CheckboxGroup must have children of type Checkbox');

		return null;
	}

	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ fieldState: { error } }) => (
				<AkselLocale>
					<Fieldset
						legend={label ?? ''}
						hideLegend={!label}
						size="small"
						{...(required ? { 'aria-required': true } : {})}
						{...(error ? { error: error.message } : {})}
					>
						{children}
					</Fieldset>
				</AkselLocale>
			)}
			{...props}
		/>
	);
}
